import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const useStyles = makeStyles()((theme) => ({
  clearFilters: {
    flexShrink: 0,
    alignSelf: 'center',
    padding: '4px 2px',
    minWidth: 0,
    textTransform: 'none',
    color: '#A8A8A8',
    gap: '4px',
    ':hover': {
      backgroundColor: 'transparent',
    },
    ':active': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
    },
    '.MuiButton-endIcon': {
      marginLeft: 0,
      marginRight: 0,
      display: 'flex',
    },
    [theme.breakpoints.down(600)]: {
      fontSize: '0.6875rem',
      padding: '2px 0',
    },
  },
}));

export const ClearAllButton = () => {
  const { classes } = useStyles();

  const [, setSearchParams] = useSearchParams();

  const handleClearClick = () => {
    setSearchParams('');
  };

  return (
    <Button
      disableRipple
      className={classes.clearFilters}
      endIcon={<img src={'content/img/icDelete.svg'} alt={'delete'} />}
      onClick={handleClearClick}
      sx={{ textWrap: 'nowrap' }}
    >
      Clear All
    </Button>
  );
};
